import { render } from "./Presentation.vue?vue&type=template&id=c42d5790"
import script from "./Presentation.vue?vue&type=script&lang=js"
export * from "./Presentation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__